module.exports = __webpack_public_path__ + "static/media/Plymouth-Village-Condominium-bylaws.d151794e.pdf";